import React from 'react';
import { positionLandmarks, toCoordinates } from './nearbyLandmarks';
import css from './GoogleMapLandmarks.module.css';

const providerNames = landmarks => [
  ...new Set(
    landmarks.flatMap(place =>
      place.attributions.map(attribution => attribution.provider).filter(Boolean)
    )
  ),
];

export const StaticLandmarks = ({ landmarks, center, zoom, dimensions }) => (
  <>
    {positionLandmarks(landmarks, center, zoom, dimensions).map(place => (
      <span
        key={place.id}
        className={css.label}
        style={{
          left: `${(100 * place.x) / dimensions.width}%`,
          top: `${(100 * place.y) / dimensions.height}%`,
        }}
      >
        <span className={css.name}>{place.name}</span>
      </span>
    ))}
    <span className={css.attributions}>{providerNames(landmarks).join(', ')}</span>
  </>
);

// One overlay handles all labels; Google's draw callback keeps them attached to
// their coordinates during zoom/pan without additional Places requests.
export const createLandmarkOverlay = (map, landmarks) => {
  const maps = window.google.maps;
  class LandmarkOverlay extends maps.OverlayView {
    onAdd() {
      this.labels = landmarks.map(place => {
        const element = document.createElement('span');
        element.className = css.label;
        const name = document.createElement('span');
        name.className = css.name;
        name.textContent = place.name;
        element.appendChild(name);
        this.getPanes().overlayLayer.appendChild(element);
        return element;
      });
      this.attribution = document.createElement('span');
      this.attribution.className = css.attributions;
      this.attribution.textContent = providerNames(landmarks).join(', ');
      map.getDiv().appendChild(this.attribution);
    }

    draw() {
      const center = toCoordinates(map.getCenter());
      const dimensions = { width: map.getDiv().offsetWidth, height: map.getDiv().offsetHeight };
      const visible = positionLandmarks(landmarks, center, map.getZoom(), dimensions);
      this.labels.forEach((element, index) => {
        const place = landmarks[index];
        element.style.display = visible.some(p => p.id === place.id) ? '' : 'none';
        const point = this.getProjection().fromLatLngToDivPixel(
          new maps.LatLng(place.position.lat, place.position.lng)
        );
        element.style.left = `${point.x}px`;
        element.style.top = `${point.y}px`;
      });
    }

    onRemove() {
      this.labels?.forEach(element => element.remove());
      this.attribution?.remove();
    }
  }
  const overlay = new LandmarkOverlay();
  overlay.setMap(map);
  return overlay;
};
